// src/Hooks/useLoading.js
import { useCallback, useEffect, useState } from "react";

// Quanto tempo uma requisição pode demorar antes do overlay aparecer
export const SLOW_THRESHOLD_MS = 800;

// Hard cap: se por qualquer motivo o stop não chegar, libera depois disso
export const MAX_VISIBLE_MS = 15000;

let listeners = new Set();
let activeCount = 0;
let safetyTimer = null;

function emit() {
  listeners.forEach((fn) => fn(activeCount));
}

function armSafety() {
  if (safetyTimer) clearTimeout(safetyTimer);
  safetyTimer = setTimeout(() => {
    // Destrava o overlay: algum start() não teve stop() correspondente
    activeCount = 0;
    safetyTimer = null;
    emit();
  }, MAX_VISIBLE_MS);
}

function disarmSafety() {
  if (safetyTimer) {
    clearTimeout(safetyTimer);
    safetyTimer = null;
  }
}

function inc() {
  activeCount += 1;
  if (activeCount === 1) armSafety();
  emit();
}

function dec() {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount === 0) disarmSafety();
  emit();
}

export default function useLoading() {
  const [count, setCount] = useState(activeCount);

  useEffect(() => {
    listeners.add(setCount);
    setCount(activeCount);
    return () => listeners.delete(setCount);
  }, []);

  const start = useCallback(inc, []);
  const stop = useCallback(dec, []);

  const wrap = useCallback(
    async (promiseOrFn) => {
      inc();
      try {
        const result =
          typeof promiseOrFn === "function" ? promiseOrFn() : promiseOrFn;
        return await result;
      } finally {
        dec();
      }
    },
    []
  );

  return { loading: count > 0, start, stop, wrap };
}